import { render, staticRenderFns } from "./LinkingLists.vue?vue&type=template&id=a4a2bc56&scoped=true&"
import script from "./LinkingLists.vue?vue&type=script&lang=js&"
export * from "./LinkingLists.vue?vue&type=script&lang=js&"
import style0 from "./LinkingLists.vue?vue&type=style&index=0&id=a4a2bc56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a2bc56",
  null
  
)

export default component.exports